package com.milta.feature.route.data.remote.dto

import com.milta.feature.route.domain.entity.Delivery
import com.milta.feature.route.domain.entity.DeliveryStatus
import com.milta.feature.route.domain.entity.GeocodeStatus
import com.milta.feature.route.domain.entity.toGeocodeFailureReason
import kotlinx.serialization.Serializable

/** Mirrors backend `DeliverySummaryDto` (MIL-38 — one entry of `RouteDetailDto.deliveries`).
 * `geocodeStatus` added by MIL-45. */
@Serializable
data class DeliveryDto(
    val id: String,
    val sortOrder: Int,
    val recipientName: String,
    val address: String,
    val status: String,
    val geocodeStatus: String,
    val deliveryTimeLimit: String? = null,
    // Minimum 1 package per delivery (a missing field reads as 1, never 0).
    val packageCount: Int = 1,
    val geocodeFailureReason: String? = null,
    val resolvedAddress: String? = null,
    // Réunion 28/10 (point 5) — real validation time (ISO 8601 with offset; the phone's own time for
    // an offline validation), set for Completed/Failed only; null from an older backend.
    val completedAt: String? = null,
    val phoneNumber: String? = null,
)

/** Request body of PUT /routes/{routeId}/deliveries/{deliveryId}/address (MIL-99) — a picked HERE
 * suggestion, its coordinates sent as-is so the server doesn't geocode again. */
@Serializable
data class UpdateDeliveryAddressRequest(
    val address: String,
    val latitude: Double,
    val longitude: Double,
)

fun DeliveryDto.toDomain() = Delivery(
    id = id,
    sortOrder = sortOrder,
    recipientName = recipientName,
    address = address,
    status = when (status) {
        "Completed"  -> DeliveryStatus.Completed
        "Failed"     -> DeliveryStatus.Failed
        "Untreated"  -> DeliveryStatus.Untreated
        else         -> DeliveryStatus.Pending
    },
    geocodeStatus = when (geocodeStatus) {
        "Geocoded" -> GeocodeStatus.Geocoded
        "Failed"   -> GeocodeStatus.Failed
        "Degraded" -> GeocodeStatus.Degraded
        else       -> GeocodeStatus.Pending
    },
    deliveryTimeLimit = deliveryTimeLimit,
    packageCount = packageCount,
    geocodeFailureReason = geocodeFailureReason.toGeocodeFailureReason(),
    resolvedAddress = resolvedAddress,
    completedAt = completedAt,
    phoneNumber = phoneNumber,
)
